import { getOwnConfig, importSync, macroCondition } from '@embroider/macros';

export default (importSync(
  macroCondition(getOwnConfig().isSsrBuild)
    ? 'rise-ui/stub/services/time-series/graph-results.js'
    : 'rise-ui/stubbed/services/time-series/graph-results.js'
)).default;
